import { Radio } from "@material-ui/core"

const NCRadio = props => {
  return <Radio {...props} />
}
export default NCRadio
